import { Flex, Text } from '@chakra-ui/react';
import { memo, useMemo } from 'react';

const AVATAR_COLORS = [
  '#B91C1C', // red
  '#15803D', // green
  '#CA8A04', // yellow
  '#1D4ED8', // blue
  '#7C3AED', // purple
  '#0891B2', // cyan
  '#C2410C', // orange
  '#BE185D', // pink
];

function getColorForInitials(initials: string): string {
  let hash = 0;
  for (let i = 0; i < initials.length; i++) {
    hash = hash * 31 + initials.charCodeAt(i);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

interface Props {
  initials: string;
  size?: string;
}

const PartnerAvatar = memo(({ initials, size = '28px' }: Props) => {
  const bg = useMemo(() => getColorForInitials(initials), [initials]);

  return (
    <Flex
      w={size}
      h={size}
      borderRadius="full"
      bg={bg}
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
    >
      <Text fontSize={size === '40px' ? 'xs' : 'md'} fontWeight="bold" color="white">
        {initials}
      </Text>
    </Flex>
  );
});
PartnerAvatar.displayName = 'PartnerAvatar';

export default PartnerAvatar;
